import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

const url = `${environment.apiBaseUrl}platform/organization-levels`;

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {
  organizationLevels: any

  constructor(private http: HttpClient) { }

  get(): Observable<OrganizationModel.Organization[]> {
    return this.http.get<OrganizationModel.Organization[]>(`${url}`);
  }

  setOrganizationLevels(data: any): void {
    this.organizationLevels = data;
  }

  getStoredOrganizationLevels(): any {
    return this.organizationLevels;
  }

  teamHealthTeams(): Observable<Team.TeamModel[]> {
    return this.http.get<Team.TeamModel[]>(`${url}/all/teams`);
  }

  post(data: OrganizationModel.Organization): Observable<any> {
    return this.http.post<any>(`${url}`, data);
  }

  delete(id: string): Observable<any> {
    return this.http.delete<any>(`${url}/${id}`);
  }

  update(data): Observable<any> {
    return this.http.put<any>(`${url}/${data.id}`, data);
  }
}
